import { render } from "./Questionnaire.vue?vue&type=template&id=d159c460&scoped=true&ts=true&lang=pug"
import script from "./Questionnaire.vue?vue&type=script&setup=true&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&setup=true&lang=ts"

import "./Questionnaire.vue?vue&type=style&index=0&id=d159c460&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d159c460"]])

export default __exports__